module.exports = __webpack_public_path__ + "img/logolar.239f0b76.webp";